import r2wc from '@r2wc/react-to-web-component';
import { WebComponentWrapper } from './WebComponentWrapper.tsx';
import AnalysisPage from '../components/Pages/AnalysisPage.tsx';

const WrappedPage = ({ year }: { year?: number }) => {
	return (
		<WebComponentWrapper year={year}>
			<AnalysisPage />
		</WebComponentWrapper>
	);
};

export const WebAnalysisPage = r2wc(WrappedPage, {
	props: { year: 'number' }
});
